import app from "../a4_app";
import Cookies from "js-cookie"

export class SplashModule {
  constructor(element) {
    this.element = element;
    this.timers = [];
    this.init();
  }

  init() {
    if (document.documentElement.classList.contains('edit')) {
      return;
    }

    if (Cookies.get('a4_splash')) {
      this.element.remove();
      return;
    }

    window.scrollTo(0, 0);

    this.element.addEventListener("click", (e) => {
      this.hideSplash();
    }, { once: true });

    const timer = window.setTimeout(() => {
      this.hideSplash();
    }, 3000);

    this.timers.push(timer);
  }

  hideSplash() {
    this.timers.forEach((timer) => {
      window.clearTimeout(timer);
    });

    if (document.body.classList.contains('is-hiding-splash') || !document.body.classList.contains('is-viewing-splash')) {
      return;
    }

    Cookies.set('a4_splash', true);

    document.body.classList.add("is-hiding-splash");
    this.fadeOut(this.element, 700, () => {
      document.body.classList.remove("is-viewing-splash");
      document.body.classList.remove("is-hiding-splash");
      this.element.remove();
    });
  }

  fadeOut(el, duration = 1000, callback) {
    const startOpacity = parseFloat(getComputedStyle(el).opacity) || 1;
    const startTime = performance.now();

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      el.style.opacity = (1 - progress) * startOpacity;

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        // ensure it’s fully hidden
        el.style.opacity = '0';
        if (typeof callback === 'function') {
          callback();
        }
      }
    }

    requestAnimationFrame(tick);
  }
}

export const splashModules = {
  current: [],
  init: () => {
    app.addEventListener("page-load", (e) => {
      const elements = e.target.querySelectorAll(".splash-module");

      if (!Boolean(elements.length)) return;

      const instances = [...elements].map(
        (element) => new SplashModule(element)
      );

      splashModules.current = [...splashModules.current, ...instances];
    });
  }
}
